import { namespace } from '../index';
const _scopedState = state => state[namespace];

const userEmail = state => _scopedState(state).userEmail;
const userId = state => _scopedState(state).userId;
const isSupportUser = state => _scopedState(state).isSupportUser;

const password = state => _scopedState(state).password;
const repassword = state => _scopedState(state).repassword;
const avatar = state => _scopedState(state).avatar;

export default {
  userEmail,
  userId,
  isSupportUser,

  password,
  repassword,
  avatar,
};
